import { Box, Container, Image, Stack, Text } from "@chakra-ui/react";
import React, { useEffect, useRef } from "react";
import { withTranslation } from "react-i18next";
import { GoBook } from "react-icons/go";
import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { getAllSubjectsRequest } from "../../../modules/admin-modules/subjects/Actions";
import { useDispatch, useSelector } from "react-redux";
const LatestCourses = ({ t }) => {
  const baseUrl = "https://api.asquera.com/";
  const dispatch = useDispatch();
  const subjects = useSelector((state) => state.subjects.subjects);
  useEffect(() => {
    dispatch(getAllSubjectsRequest());
  }, []);

  const subjectsOptions = subjects?.map((data) => {
    return { value: data.id, name: data.name, logo: data.logo, nameAr: data.nameAr };
  });

  // filter duplicates logos
  const filteredSubjects = subjectsOptions?.filter((elem, index, self) =>
    index === self.findIndex((t) => t.logo === elem.logo)
  );


  function SampleNextArrow(props) {
    return (
      <div
        style={{
          display: "flex",
          background: "#e4e8ebd9",
          width: "50px",
          height: "40px",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "10px",
          marginTop: 0,
        }}
        onClick={gotoNext}
      >
        <IoMdArrowForward color="white" fontWeight="700" fontSize="20px" />
      </div>
    );
  }

  function SamplePrevArrow(props) {
    return (
      <div
        style={{
          display: "flex",
          background: "#e4e8ebd9",
          width: "50px",
          height: "40px",

          alignItems: "center",
          justifyContent: "center",
          borderRadius: "10px",
        }}
        onClick={gotoPrev}
      >
        <IoMdArrowBack color="white" fontWeight="700" fontSize="20px" />
      </div>
    );
  }
  const settings = {
    dots: false,
    // infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    // autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    cssEase: "linear",
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          // infinite: true,
          arrows: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          infinite: true,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: false,
        },
      },
    ],
  };
  const sliderRef = useRef();
  const gotoNext = () => {
    sliderRef.current.slickNext();
  };
  const gotoPrev = () => {
    sliderRef.current.slickPrev();
  };
  return (
    <Container maxW={"container.xl"} my={16} id="subjects" position="relative">
      <Text
        textAlign="center"
        fontWeight="500"
        fontSize={{ base: "20px", md: "25px" }}
        mb={8}
      >
        {t("components.latestCources.title")}{" "}
        <Image src={require("../../../assets/line.jpg")} m="auto" mt={3} />
      </Text>

      <Slider {...settings} ref={sliderRef}>
        {filteredSubjects?.map((elem, index) => {
          return (
            <Box
              key={index}
              bg="white"
              borderRadius="20px"
              minH="160px"
              p="24px"
              w={{ base: "90% !important", md: "320px" }}
              boxShadow="0 8px 25px rgba(0,0,0,0.08)"
              border="1px solid"
              borderColor="gray.100"
              transition="all 0.3s ease"
              _hover={{
                transform: "translateY(-5px)",
                boxShadow: "0 15px 35px rgba(0,0,0,0.12)",
                borderColor: "blue.200"
              }}
              position="relative"
              overflow="hidden"
            >
              <Stack direction="row" align="center" spacing={4} h="full">
                <Box 
                  width="80px" 
                  h="80px" 
                  borderRadius="16px"
                  overflow="hidden"
                  bg="gray.50"
                  border="2px solid"
                  borderColor="gray.100"
                  flexShrink={0}
                >
                  <Image
                    borderRadius="14px"
                    src={elem?.logo ? baseUrl + elem?.logo : "/logo.png"}
                    h="100%"
                    w="100%"
                    objectFit="cover"
                    color="transparent"
                  />
                </Box>

                <Stack flex="1" spacing={2}>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Box
                      p={1.5}
                      bg="blue.50"
                      borderRadius="full"
                      color="blue.500"
                    >
                      <GoBook fontSize="14px" />
                    </Box>
                    <Text fontSize="16px" fontWeight="600" color="gray.700">
                      {elem?.name}
                    </Text>
                  </Stack>
                  
                  <Text fontSize="18px" fontWeight="700" color="gray.800">
                    {elem?.nameAr}
                  </Text>
                  
                  <Box
                    mt={2}
                    p={2}
                    bg="blue.50"
                    borderRadius="8px"
                    border="1px solid"
                    borderColor="blue.100"
                  >
                    <Text fontSize="12px" color="blue.600" textAlign="center" fontWeight="500">
                      {t("components.latestCources.viewCourse") || "View Course"}
                    </Text>
                  </Box>
                </Stack>
              </Stack>
            </Box>
          );
        })}
      </Slider>
      <Stack
        flexDir="row"
        gap={6}
        position="absolute"
        top="65%"
        left="45%"
        display={{ base: "none", md: "flex" }}
      >
        <SamplePrevArrow />

        <SampleNextArrow />
      </Stack>
    </Container>
  );
};

export default withTranslation()(LatestCourses);
